<script>
  // export let color = '#091F37';
</script>

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6 15L12 9L18 15"
    class={$$props.class || "stroke-blueish-grey-900"}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
